import { render, staticRenderFns } from "./MutipleChoiceContent.vue?vue&type=template&id=79463b7b&scoped=true&"
import script from "./MutipleChoiceContent.vue?vue&type=script&lang=js&"
export * from "./MutipleChoiceContent.vue?vue&type=script&lang=js&"
import style0 from "./MutipleChoiceContent.vue?vue&type=style&index=0&id=79463b7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79463b7b",
  null
  
)

export default component.exports